import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { get } from 'api/requests';

const initialState: StandStore = {
  stand: {} as Stand,
  loading: false,
};

export const standSlice = createSlice({
  name: 'stand',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getStand.pending, state => {
        state.loading = true;
      })
      .addCase(getStand.fulfilled, (state, { payload }) => {
        state.loading = false;

        if (payload) {
          state.stand = payload;
        }
      })
      .addCase(getStand.rejected, state => {
        state.loading = false;
      });
  },
});

export const getStand = createAsyncThunk('stand/get', async (params, thinkApi) => {
  try {
    const { data } = await get<Stand>('/api/version/', params);
    return data;
  } catch (error) {
    thinkApi.rejectWithValue(error);
  }
});

interface Stand {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  version: any; // "dev",
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  stand: any; // "DEV",
  pythonVersion: string;
  distributions: string[];
}

interface StandStore {
  stand: Stand;
  loading: boolean;
}
